import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagAtencionIsla = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagAtencionIsla'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagAtencionIsla' label='Atencion Isla' />}
    </Field>
  )
}

export default React.memo(FlagAtencionIsla)
